import {Trans, useTranslation} from 'gatsby-plugin-react-i18next';

const Incentivization = () => {
    const { t } = useTranslation();
    return (
    <>
        <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 ir-1">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12 col-sm-8 col-md-8 col-lg-8">
                    <h1 className="font-weight-semibold hero-heading mt-5 no-br">
                        <Trans>Rewarding Wellness <br/>Achievements</Trans>
                    </h1>
                    <p className="hero-para font-weight-semibold no-br">
                        <Trans>Motivating healthy behaviors through our <br/>innovative incentives and rewards system.</Trans>
                    </p>
                    <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Let's Talk</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="">
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-5">
                            <div className="col-12">
                                <div className="features-label red-font">
                                    <Trans>Points System</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading'><Trans>Earn Points, Unlock Wellness!</Trans></h2>
                                <p className='section-para font-weight-normal'><Trans>Accumulate points by achieving wellness milestones and participating in challenges.</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-7 cta-img'>
                            <div className='d-flex justify-content-center'>
                                <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1701080524/VantageFit/2023/Incentivization_and_Rewards-Earn_Points_Unlock_Wellness.webp`)} loading='lazy' alt="Earn Points, Unlock Wellness!" width="500" height="581"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex flex-row-reverse m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-6">
                            <div className="col-12">
                                <div className="features-label green-font">
                                    <Trans>Redemption Catalog</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading'><Trans>Your Wellness Treasure Trove!</Trans></h2>
                                <p className='section-para font-weight-normal'><Trans>Browse our rewards catalog and redeem your hard-earned points with our exciting gift cards.</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-5 cta-img'>
                            <div className='col-12 d-flex justify-content-center'>
                                <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1701080525/VantageFit/2023/Incentivization_and_Rewards-Your_Wellness_Treasure_Trove.webp`)} loading='lazy' alt="Your Wellness Treasure Trove!" width="500" height="480"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <div className="container custom_container d-flex m-d-block justify-content-center align-items-center">
                        <div className="col-12 col-md-5">
                            <div className="col-12">
                                <div className="features-label orange-font">
                                    <Trans>The Power of Rewards</Trans>
                                </div>
                                <h2 className='font-weight-semibold py-2 section-heading no-br'><Trans>Beyond Fit Points!</Trans></h2>
                                <p className='section-para font-weight-normal'><Trans>Elevate wellness with exclusive badges and certificates, adding extra joy to fitness achievements.</Trans></p>
                            </div>
                        </div>
                        <div className='col-12 col-md-7 cta-img'>
                            <div className='d-flex justify-content-center'>
                                <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1701080528/VantageFit/2023/Incentivization_and_Rewards-Beyond_Fit_Points.webp`)} loading='lazy' alt="Beyond Fit Points!" width="500" height="533"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="section-heading-top cursive">
                <h2 className="section-heading font-weight-bold text-center mb-4"><Trans i18nKey="subtextfeat9">Wellness that &nbsp;<span className="charmonman green-clr">Rewards</span>&nbsp;you</Trans>&nbsp;!</h2>
                <div className="section-para text-center"><Trans>Experience the motivation and joy of earning rewards for your wellness efforts.</Trans></div>
            </div>
        </section>

        <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center no-br">
                        <Trans>Start Earning Wellness Rewards Today!</Trans>
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5 text-white">
                        <Trans>Motivate yourself and your team with our incentives and rewards system.</Trans>
                    </p>
                    <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Let's Talk</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </>
  )
}

export default Incentivization
